<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :return-value.sync="date"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <div class="d-flex">
        <v-btn
          @click="addDay(-1)"
          class="left-btn arrow-button elevation-0"
          color="white"
          ><v-icon>mdi-arrow-left</v-icon></v-btn
        >
        <v-btn
          class="date-btn rounded-0 black--text elevation-0"
          v-on="on"
          color="white"
        >
          <span class="black--text">{{ date }}</span>
        </v-btn>
        <v-btn
          @click="addDay(1)"
          :disabled="disableDateForwardButton"
          class="right-btn arrow-button elevation-0"
          color="white"
          ><v-icon>mdi-arrow-right</v-icon></v-btn
        >
      </div>
    </template>
    <v-date-picker
      v-model="date"
      @change="onDateMenuChange"
      no-title
      scrollable
      :max="maxDate"
      color="primary"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'DatePicker',
  props: {
    currentDate: {
      type: String,
      required: true,
    },
    maxDate: {
      type: String,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      date: this.currentDate,
      menu: false,
    };
  },
  computed: {
    disableDateForwardButton() {
      return this.date === this.maxDate;
    },
  },
  watch: {
    date(newVal) {
      this.$emit('dateChanged', newVal);
    },
  },
  methods: {
    onDateMenuChange() {
      this.$refs.menu.save(this.date);
      this.menu = false;
    },
    addDay(amount) {
      const currentSelectedDate = new Date(this.date);
      const nextDay = new Date(currentSelectedDate);
      nextDay.setDate(currentSelectedDate.getDate() + (amount));
      this.date = nextDay.toISOString().substring(0, 10);
    },
  },
};
</script>

<style scoped>
.arrow-button {
  min-width: 36px !important;
  width: 36px !important;
}

.date-btn {
  border-left: 0 !important;
  border-right: 0 !important;
}

.left-btn {
  border-radius: 35% 0 0 35%;
}

.right-btn {
  border-radius: 0 35% 35% 0;
}
</style>
